module.exports = __webpack_public_path__ + "static/media/blue-diamond-thumbnail.15cc6af4.webp";